import { useState } from 'react';

const defaultPlan = {
  type: 'annual',
  price: 60.0,
  currency: 'USD',
  planName: 'annual',
  planId: 'annual',
};

const useSelectPlan = () => {
  const [selectedPlan, setSelectedPlan] = useState(defaultPlan);

  const handleSelectPlan = (plan) => {
    if (selectedPlan?.type === plan.type) {
      setSelectedPlan(null);
    } else {
      setSelectedPlan(plan);
    }
  };

  return {
    selectedPlan,
    handleSelectPlan,
  };
};

export default useSelectPlan;